import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EscolarService } from 'src/app/services/escolar.service';
import { Notice } from 'src/app/models/notice.model';
import { IconsService } from 'src/app/shared/services/icons.service';
import { ToastrService } from 'ngx-toastr';
import { School } from 'src/app/models/school.model';
import { Campus } from 'src/app/models/campus.model';
import { environment } from 'src/environments/environment';
import { SecureStorageService } from 'src/app/services/secure-storage.service';

@Component({
  selector: 'app-edit-notices-bulletin',
  template: `
    <div class="bg-white p-4 rounded-4 shadow-sm">
      <div class="d-flex mb-4">
        <img [src]="environment.ESCALAS_WSPREFIX + (school?.logo?.url || '')" width="18" height="18" class="ms-2" *ngIf="school?.logo">
        <fa-icon [icon]="icons.faChevronRight" class="mx-2" style="font-size: 0.7em; margin-top: 2px;"></fa-icon>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
      <div class="alert alert-warning alert-dismissible fade show rounded-4 overflow-hidden" role="alert" *ngIf="notice&&notice.expired_at">
        <fa-icon [icon]="icons.faCircleInfo" class="me-2"></fa-icon>
        <strong>Este aviso expiró</strong> el , ya no es visible para los usuarios a los que se les compartió su contenido.            
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
      <app-form-notice 
        [notice]="notice" 
        [school]="school"
        [campuses]="campuses"
        [loading]="loading"         
        (noticeData)="updateNotice($event)"
      ></app-form-notice>
    </div>
  `,
  styleUrls: []
})
export class EditNoticesBulletinComponent implements OnInit {
  environment = environment;
  notice: Notice | null = null;
  school: School | null = null;
  campuses: Campus[] = [];
  loading: boolean = false;

  constructor(
    private readonly escolarService: EscolarService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly toastr: ToastrService,
    public icons: IconsService,
    private readonly secureStorage: SecureStorageService
  ) {
    this.route.params.subscribe((params) => {
      this.loading = true;
      this.escolarService.getNotice(params['id']).subscribe((notice: any) => {
        this.notice = notice;
        this.loading = false;
      });
    });
  }

  ngOnInit(): void {
    this.loadStoredData();
  }

  private async loadStoredData() {
    try {
      // Load school from secure storage
      const schoolData = await this.secureStorage.getItem('school');
      this.school = schoolData ? JSON.parse(schoolData) : null;
      console.log('EditNoticesBulletinComponent - School loaded:', this.school);
      
      // Load campuses from secure storage
      this.campuses = await this.secureStorage.getObject<Campus[]>('campuses') || [];
      console.log('EditNoticesBulletinComponent - Campuses loaded:', this.campuses);
      console.log('EditNoticesBulletinComponent - Campuses length:', this.campuses.length);
    } catch (error) {
      console.error('EditNoticesBulletinComponent - Error loading data from secure storage:', error);
      this.campuses = [];
      this.school = null;
    }
  }

  updateNotice(data: any) {
    this.escolarService.updateNotice(data.notice_id, data).subscribe({
      next: (notice: any) => {
        this.toastr.success('Aviso actualizado', 'Éxito');
      },
      error: (error: any) => {
        this.toastr.error('Error al crear el aviso', 'Error');
      }
    });
  }
}
